import { HomeWorkoutSequence, Instructor } from 'fitbeat.gym-core';
import React, { FunctionComponent } from 'react';
import { SafeAreaView, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import FastImage from 'react-native-fast-image';
import CalendarIcon from '../../../assets/images/calendar.svg';
import DurationIcon from '../../../assets/images/duration.svg';
import { Icon } from '../../../components';
import Theme from '../../../theme';
import { LinearGradient } from '../../../ui/components';
import { getWorkoutDuration } from '../../../utils';
import { defaultScale } from '../../../utils/scaling';
import EditIcon from '../.././../assets/images/edit-pen.svg';
import { workoutSummaryHeaderStartText } from '../../helpers';

interface IProps {
  openInstructorSetup: () => void;
  leaveHomeWorkout: () => void;
  instructor: Instructor | null;
  homeWorkout: HomeWorkoutSequence;
  t: (key: string, options?: any) => string;
  instructorName: string;
  isGroupWorkout: boolean;
  enableInstructorChange: boolean;
}

export const PreworkoutSetupInstructorHeader: FunctionComponent<IProps> = ({
                                                                             openInstructorSetup,
                                                                             homeWorkout,
                                                                             instructor,
                                                                             t,
                                                                             leaveHomeWorkout,
                                                                             instructorName,
                                                                             isGroupWorkout,
                                                                             enableInstructorChange,
                                                                           }) => {
  const iconSize = defaultScale(15);
  const editIconSize = defaultScale(15);

  return (
    <View style={styles.container}>
      <SafeAreaView style={{ flex: 0 }} />
      <TouchableOpacity onPress={leaveHomeWorkout} style={styles.close}>
        <Icon name={'md-close'} color={Theme.WHITE} size={defaultScale(35)} />
      </TouchableOpacity>
      {
        instructor && instructor.avatarUrl &&
        <View style={styles.instructorImageContainer}>
          <FastImage
            style={styles.instructorImage}
            source={{ uri: instructor.avatarUrl }}
            resizeMode={FastImage.resizeMode.contain}
          />
        </View>
      }
      <LinearGradient
        colors={['transparent', Theme.BLACK]}
        style={styles.gradient}
      />
      <View style={styles.contentContainer}>
        {
          !!instructorName &&
          <TouchableOpacity
            style={styles.iconContainer}
            disabled={!enableInstructorChange}
            onPress={openInstructorSetup}>
            <Text style={styles.heading}>
              {t('homeWorkouts:trainWith', { instructorName })}
            </Text>
            { enableInstructorChange &&
              <EditIcon
              color={Theme.PRIMARY}
              width={editIconSize}
              height={editIconSize}
            />
            }

          </TouchableOpacity>
        }
        <View style={styles.iconContainer}>
          <CalendarIcon
            width={iconSize}
            height={iconSize}
          />
          <Text style={styles.iconText}>
            {workoutSummaryHeaderStartText(homeWorkout.startTimeOfFirstExercise, t, isGroupWorkout)}
          </Text>
        </View>
        <View style={styles.iconContainer}>
          <DurationIcon
            width={iconSize}
            height={iconSize}
            color={Theme.WHITE}
          />
          <Text style={styles.iconText}>
            {getWorkoutDuration[homeWorkout.workoutType]}
          </Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    height: defaultScale(185),
    backgroundColor: Theme.BLACK,
  },
  instructorImageContainer: {
    height: '100%',
    width: '50%',
    position: 'absolute',
    right: 0,
    bottom: 0,
  },
  instructorImage: {
    height: '100%',
    aspectRatio: 1,
    zIndex: 0,
  },
  gradient: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    left: 0,
    height: '50%',
    opacity: 0.7,
  },
  contentContainer: {
    flex: 1,
    justifyContent: 'flex-end',
    marginLeft: defaultScale(20),
    zIndex: 2,
    paddingBottom: defaultScale(10),
  },
  heading: {
    ...Theme.textStyle.heading,
    color: Theme.WHITE,
    marginRight: defaultScale(10),
  },
  bodyText: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.WHITE,
  },
  iconContainer: {
    flexDirection: 'row',
    marginRight: defaultScale(25),
    alignItems: 'center',
    paddingVertical: 5,
  },
  iconText: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.WHITE,
    marginLeft: defaultScale(8),
  },
  loadingIcon: {
    flex: 1,
    justifyContent: 'center',
  },
  close: {
    zIndex: 3,
    paddingRight: defaultScale(10),
    alignSelf: 'flex-end',
  },
});
